export const NOTIFICATION_ROUTES: Readonly<Record<string, string | null>> = {
  '/bookings/:id': '/bookings',
  '/bookings/:id/split': null,
  '/booking/split/join/:id': null,
  '/tournament/:id': '/tournaments/:id',
  '/match/results': null,
  '/match/:id': null,
  '/payments/:id': null,
  '/payment/pending': null,
  '/wallet': null,
  '/family/approvals': null,
  '/chat/:id': null,
  '/chat/trainer/:id': null,
  '/chat/direct/:id': null,
  '/tournament/:id/chat': null,
  '/match/:id/chat': null,
  '/group-session/:id/chat': null,
  '/friends': null,
  '/friends/requests': null,
  '/group-sessions': null,
  '/fitness-session': null,
  '/news/:id': null,
  '/finance': '/finance',
  '/pos': '/pos',
};

export function resolveNotificationUrl(actionUrl: string | null | undefined): string | null {
  const raw = actionUrl?.trim();
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.includes('..') || raw.includes('\\')) {
    return null;
  }
  const path = (raw.split('?')[0] ?? '').replace(/\/+$/, '') || '/';
  const segments = path.split('/');
  for (const [template, target] of Object.entries(NOTIFICATION_ROUTES)) {
    const parts = template.split('/');
    if (parts.length !== segments.length) continue;
    let id: string | undefined;
    const matches = parts.every((part, i) => {
      const segment = segments[i];
      if (part === ':id') {
        id = segment;
        return !!segment;
      }
      return part === segment;
    });
    if (!matches) continue;
    return target === null ? null : target.replace(':id', encodeURIComponent(id ?? ''));
  }
  return null;
}
